import { topics } from "@/mocks/site";
import { dramas } from "@/mocks/dramas";

type TopicSectionProps = {
  onPickCategory: (category: string) => void;
};

export default function TopicSection({ onPickCategory }: TopicSectionProps) {
  const picks = [...dramas].sort((a, b) => b.heat - a.heat).slice(0, 3);

  return (
    <section id="topics" className="w-full border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Topics</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">题材热词</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              这些是合集里出现频率最高的情节切入点，数字代表对应合集数量。看标题之前先扫一遍，更容易判断内容走向。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {topics.map((topic, index) => (
                <span
                  key={topic.id}
                  className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm ${
                    index % 3 === 0
                      ? "bg-accent-100 text-accent-900"
                      : index % 3 === 1
                      ? "bg-secondary-100 text-secondary-800"
                      : "bg-primary-100 text-primary-800"
                  }`}
                >
                  {topic.name}
                  <span className="text-xs opacity-70">{topic.count}</span>
                </span>
              ))}
            </div>
          </div>

          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Popular</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">相关推荐</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              按站内热度排出的前三部，点击后会自动跳到合集区并选中对应题材。
            </p>
            <ul className="mt-6 space-y-3">
              {picks.map((drama, index) => (
                <li key={drama.id}>
                  <a
                    href="#catalog"
                    onClick={() => onPickCategory(drama.category)}
                    className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
                  >
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-foreground-950 font-heading text-base font-bold text-background-50">
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate font-medium text-foreground-900 group-hover:text-primary-700">
                        {drama.title}
                      </span>
                      <span className="mt-0.5 block truncate text-xs text-foreground-500">
                        {drama.category} · {drama.episodes} 集 · 热度 {drama.heat.toLocaleString()}
                      </span>
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400 group-hover:text-primary-600">
                      <i className="ri-arrow-right-line" aria-hidden="true" />
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}